<template>
  <div class="storeApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li v-for="(item,i) in lock">
        <!--<img class="fmt" :src="baseUrl+item.image" />-->
        <div class="fmt" :style="'background:url('+baseUrl+item.image+') no-repeat left center;background-size:100%'"></div>
        <div class="right">
        <h2>{{item.title}}</h2>
        <p>分类：{{item.cname}}</p>
        <div class="price">
          <i><b>¥</b> {{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>
          <span>￥{{item.price}}</span>
        </div>
        </div>
        <a style="bottom:40px" @click="toPush(item.id,'goodsedit',item.stock - item.use)">编辑物品</a>

        <a style="color:#f00;border-color:#f00" @click="toPush(item.id,'goodsorder',item.stock - item.use)">物品订单</a>
        <div class="stock">剩余{{item.stock - item.use}}件</div>
      </li>
    </ul>
  </div>
  
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        lock:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });

      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/store?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }

    },
    mounted() {
      this.beforeMount();
      this.stores();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      stores:function(){
        var that = this; 
        var id = that.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/store/index',
          params:{
            store_id:id,
            page:1
          }
        }).then(function(response){
          var res = response.data.data;
          that.lock = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      toPush:function(index,url,num){
        /*if(num <= 0){
          this.$alert('物品已租完，请借用其他物品', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })*/

        window.location.href = 'http://user.4008005216.com/main/'+url+'?id='+index;
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .storeApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }

  .storeApp ul{
    width:94%;
    display: block;
    margin: 0 auto;
    padding-top:15px;
  }

  .storeApp ul li{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius:8px;
    width:100%;
    padding:13px 0;
    position:relative;
    margin-bottom:15px;
  }
  .storeApp ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .storeApp ul li .fmt{
    float:left;
    width:30%;
    border-radius:6px;
    margin-left:3%;
    height:80px;
    background-size:100% !important
  }
  .storeApp ul li .right{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .storeApp ul li h2{
    font-size:15px;
    padding:0px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    padding-right:6px
  }
  .storeApp ul li p{
    font-size:14px;
    color:#666;
    padding-top:8px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    padding-right:6px
  }
  .storeApp ul li .price{
    padding-top:8px
  }
  .storeApp ul li .price span{
    text-decoration: line-through;
    color:#999;
    font-size:13px;
    padding-left:5px;
  }


  .storeApp ul li .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .storeApp ul li .price i{
    color: #FF6600;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0px;
  }
  .storeApp ul li .price b{
    font-size:12px;
  }
  .storeApp ul li a{
    position:absolute;
    right:10px;
    bottom:-6px;
    transform: translateY(-50%);
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
  .storeApp ul li .stock{
    position:absolute;
    left:3%;
    top:13px;
    background:rgba(255,0,0,.4);
    color:#fff;
    font-size:14px;
    border-radius:6px 0 6px 0;
    padding:2px 5px
  }
</style>